export const KEY_STATUS = 'status';
export const KEY_MESSAGE = 'message';
export const KEY_OBJ = 'obj';

export const CODE_SUCCESS = 200;
export const CODE_ERROR   = 300;
export const CODE_TIMEOUT = 301;

export const JY_BACKURL = 'JY_BACKURL';
export const JY_BACKURL_CLEAR = 'JY_BACKURL_CLEAR';

export const JY_TOKEN_GET = 'JY_TOKEN_GET';
export const JY_SETTINGVUE_SET = 'JY_SETTINGVUE_SET';

export const JY_LOGIN = 'JY_LOGIN';
export const JY_LOGIN_TOKEN = 'JY_LOGIN_TOKEN';
export const JY_LOGOUT = 'JY_LOGOUT';
export const JY_LOGIN_CHECK = 'JY_LOGIN_CHECK';
export const JY_LOAD_PERMISSIONS = 'JY_LOAD_PERMISSIONS';

export const JY_LOGIN_MEMBER = 'JY_LOGIN_MEMBER';
export const MEMBER_ADDRESS = 'MEMBER_ADDRESS';

/* 基础信息 */
export const BASE_LOAD = {
  baseLoading: 'baseLoading',
  newscateList: 'newscateList', // 新闻类别
  activitycateList: 'activitycateList', // 活动类别
  kpcateList: 'kpcateList', // 科普类别
  sexLabel: 'sexLabel'
}

// 各种状态
export const STATUS = {
  statusLoading: 'statusLoading',
  checkStatus: 'checkStatus',
  logstype: 'logstype',
  orderStatus: 'orderStatus'
};

export const MEMBER = {
  reloadList: 'member_reloadList' // 会员信息
};

export const OTHER = {
  reloadNews: 'other_reloadNews', // 新闻信息
  reloadActivity: 'other_reloadActivity', // 活动信息
  reloadKp: 'other_reloadKp', // 科普信息
  reloadOrder: 'other_reloadOrder', // 订单信息
  reloadWebUser: 'other_reloadWebUser', // [我的] 页面刷新
  reloadAddress: 'other_reloadAddress', // [我的] 地址刷新
};
